enum CacheHealth {
    Normal = 0,
    CacheCorrupt = 1,
    TooManyInstallError = 2,
}

export default CacheHealth;
